import React, { useRef } from "react";
import FacebookIcon from "../../assets/facebook-icon.png";
import TwitterIcon from "../../assets/twitter.png";
import YoutubeIcon from "../../assets/youtube.png";
import InstagramIcon from "../../assets/instagram.png";
import emailjs from "@emailjs/browser";

const Contactme = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_ef5dd46", "template_cxtgf6n", form.current, {
        publicKey: "iUI1eWWfKxlOJYLZx",
      })
      .then(() => {
          console.log("SUCCESS!");
          e.target.reset();
          alert("Email Send Successfully.");
        },
      )
      .catch((error) => {
        console.log("FAILED...", error.text);
        alert("Some Think Went Wrong.");
      })
  };
  return (
    <div id="contact">
      <h1 className="contactPageTitle">Contact Me</h1>
      <span className="contactDesc">
        Please fill out the form below to discuss any work opportunities
      </span>
      <form action="" className="contactForm" ref={form} onSubmit={sendEmail}>
        <input
          type="text"
          className="name"
          placeholder="Your Name"
          name="from_name"
          required
        />
        <input
          type="text"
          className="email"
          placeholder="Your Email"
          name="from_email"
          required
        />
        <textarea
          className="msg"
          name="message"
          rows="5"
          placeholder="Your Message"
          required
        ></textarea>
        <button type="submit" value="Send" className="submitBtn">
          Submit
        </button>
        <div className="links">
          <img src={FacebookIcon} alt="Facebook" className="link" />
          <img src={TwitterIcon} alt="Twitter" className="link" />
          <img src={YoutubeIcon} alt="Youtube" className="link" />
          <img src={InstagramIcon} alt="Instagram" className="link" />
        </div>
      </form>
    </div>
  );
};

export default Contactme;
